import validate from "/tmp/build/ad8838f6/customer-website-pr/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.14.1_db0@0.3.1_eslint@8.57.1_idb-keyval@6.2._yhgabb7n53rapqrwhb27gmpsg4/node_modules/nuxt/dist/pages/runtime/validate.js";
import access_45global from "/tmp/build/ad8838f6/customer-website-pr/middleware/access.global.ts";
import manifest_45route_45rule from "/tmp/build/ad8838f6/customer-website-pr/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.14.1_db0@0.3.1_eslint@8.57.1_idb-keyval@6.2._yhgabb7n53rapqrwhb27gmpsg4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}